const PropTypes = require('prop-types');
const React = require('react');
const Sortable = require('react-sortable-hoc');
const classNames = require('classnames');

class Thumb extends React.Component {
  disableEditPhoto() {
    return !this.props.allowEdit || this.isUnsupportedBrowser;
  }

  get isUnsupportedBrowser() {
    return $.browser.msie && $.browser.version && parseInt($.browser.version, 10) < 11;
  }

  edit() {
    this.props.onEdit(this.props.photo);
  }

  remove() {
    this.props.onRemove(this.props.photo);
  }

  renderEditLink() {
    if (this.disableEditPhoto()) { return null; }

    return (
      <a
        className="img-uploader__actions__action img-uploader__actions__action--edit"
        onClick={() => this.edit()}
      >
        {I18n.t('js.listingForm.photos.thumb.edit')}
      </a>
    );
  }

  render() {
    const className = classNames('img-uploader__thumb', {
      'img-uploader__thumb--with-warning': this.props.photo.showTooSmallWarning,
    });

    return (
      <div className={className} >
        <div className="img-uploader__thumb__image">
          <img
            src={this.props.photo.thumbUrl}
            role="presentation"
          />
          {/* this overlay fixes an issue in firefox that causes the dragged item to
          freeze when using the image as a drag handle */}
          <div className="img-uploader__thumb__image__overlay" />
        </div>
        <div className="img-uploader__actions">
          {this.renderEditLink()}
          <a
            className="img-uploader__actions__action img-uploader__actions__action--remove"
            onClick={() => this.remove()}
          />
        </div>
      </div>
    );
  }
}

Thumb.propTypes = {
  photo: PropTypes.object.isRequired,
  onEdit: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  allowEdit: PropTypes.bool.isRequired,
};

module.exports = Sortable.SortableElement(Thumb);



// WEBPACK FOOTER //
// ./javascripts/components/photos/thumb.jsx